module.exports = __webpack_public_path__ + "img/icon_marital.90613040.png";